<div class="load" *ngIf="loading">
  <nio-spinner *ngIf="loading"></nio-spinner>
  <p class="loading-text">Redirect...</p>
</div>